import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { DashboardModel } from '../../core/models/dashboard.model';
import { USER_CARDS, ADMIN_CARDS} from '../../core/constants/dashboard.constants'

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatTooltipModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatDividerModule
],
  templateUrl: './dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  public readonly userProfile = this.authService.userProfile;
  public readonly userRoles = this.authService.userRoles;
  public readonly userGroups = this.authService.userGroups;
  public readonly isAdmin = this.authService.isAdmin;

  username = computed(() => this.userProfile()?.username || 'Benutzer');

  readonly userCards: DashboardModel[] = USER_CARDS;
  readonly adminCards: DashboardModel[] = ADMIN_CARDS;

  navigateToCard(card: DashboardModel): void {
    if (card.action) {
      card.action();
    } else if (card.route) {
      this.router.navigate([card.route]);
    }
  }
}
